const HotelLoader = () => {
  return (
    <div className="loader-overlay">
      <img
        src={require("../../../../src/images/image (4)_2.gif")}
        alt="Loading..."
        style={{ width: 100, height: 100 }}
      />
    </div>
  );
};

export default HotelLoader;
